const GMSL = [
-38.61,
-42.01,
-41.97,
-42.71,
-37.88,
-36.1,
-36.13,
-35.55,
-35.48,
-39.27,
-37.54,
-34.54,
-36.64,
-38.8,
-40.24,
-38.35,
-36.06,
-35.24,
-35.4,
-35.82,
-28.49,
-35.73,
-34.14,
-30.28,
-29.78,
-30.55,
-32.01,
-28.82,
-26.6,
-29.36,
-30.93,
-31.51,
-32.47,
-34.32,
-32.28,
-28.39,
-31.15,
-33.35,
-30.89,
-29.33,
-34.12,
-37.43,
-36.81,
-32.28,
-35.25,
-28.69,
-31.93,
-31.71,
-33.31,
-34.63,
-35.2,
-37.95,
-35.48,
-32.64,
-40.34,
-38.62,
-32.84,
-31.49,
-31.35,
-31.68,
-28.88,
-27.03,
-25.4,
-26.18,
-27.1,
-25.57,
-23.4,
-25.64,
-20.03,
-28.4,
-32.12,
-27.87,
-26.0,
-24.96,
-24.75,
-27.61,
-25.28,
-30.5,
-34.06,
-28.93,
-29.02,
-23.92,
-30.6,
-31.36,
-31.32,
-30.16,
-38.01,
-33.48,
-31.79,
-29.13,
-32.13,
-33.37,
-29.28,
-32.39,
-30.96,
-30.22,
-28.23,
-27.1,
-24.37,
-22.85,
-17.42,
-23.04,
-24.1,
-30.35,
-24.6,
-25.6,
-23.98,
-44.45,
-27.55,
-21.86,
-26.76,
-30.59,
-32.3,
-33.65,
-27.55,
-31.18,
-27.48,
-30.86,
-29.03,
-29.07,
-32.38,
-32.43,
-29.6,
-29.57,
-30.98,
-29.1,
-28.85,
-33.72,
-28.15,
-27.75,
-26.3,
-22.1,
-24.16,
-24.0,
-24.11,
-25.24,
-22.44,
-20.05,
-19.56,
-26.69,
-18.08,
-14.02,
-18.91,
-24.0,
-23.18,
-22.64,
-28.37,
-29.5,
-27.37,
-30.01,
-27.62,
-34.85,
-29.49,
-29.29,
-29.66,
-27.37,
-26.07,
-24.97,
-29.97,
-28.76,
-25.7,
-29.7,
-25.66,
-30.77,
-28.3,
-25.39,
-24.67,
-19.88,
-20.36,
-24.96,
-18.09,
-15.91,
-15.05,
-12.41,
-10.18,
-8.44,
-12.17,
-13.24,
-11.98,
-15.85,
-16.6,
-15.03,
-23.14,
-21.35,
-24.47,
-20.8,
-25.03,
-22.2,
-22.31,
-23.49,
-24.83,
-22.26,
-22.3,
-23.08,
-21.18,
-23.68,
-24.31,
-26.95,
-25.46,
-29.91,
-29.18,
-30.43,
-27.33,
-27.76,
-29.28,
-27.9,
-27.75,
-28.0,
-24.46,
-23.19,
-23.83,
-23.68,
-22.6,
-24.21,
-21.82,
-24.03,
-24.2,
-27.94,
-23.74,
-27.68,
-26.52,
-28.27,
-26.4,
-28.46,
-30.96,
-20.44,
-23.38,
-21.77,
-23.59,
-22.55,
-24.74,
-23.68,
-28.8,
-26.82,
-24.92,
-26.1,
-24.94,
-28.39,
-26.44,
-25.27,
-23.19,
-23.3,
-22.3,
-23.53,
-18.23,
-21.5,
-17.58,
-14.13,
-14.88,
-11.58,
-14.59,
-15.23,
-16.59,
-15.8,
-18.2,
-16.1,
-17.08,
-17.64,
-19.69,
-18.72,
-18.43,
-22.2,
-23.02,
-19.67,
-19.81,
-21.86,
-18.39,
-23.71,
-23.62,
-22.55,
-24.39,
-23.34,
-23.25,
-23.41,
-24.37,
-24.96,
-22.96,
-21.11,
-20.71,
-23.26,
-19.42,
-14.49,
-17.05,
-15.89,
-11.12,
-8.72,
-8.06,
-10.85,
-2.22,
-10.09,
-13.39,
-14.72,
-18.29,
-18.54,
-15.78,
-17.09,
-16.36,
-17.44,
-16.6,
-19.09,
-15.21,
-12.22,
-19.43,
-15.72,
-16.68,
-14.1,
-15.95,
-18.61,
-19.04,
-19.29,
-19.32,
-19.68,
-15.26,
-12.71,
-11.95,
-15.73,
-10.85,
-12.25,
-10.33,
-8.28,
-5.34,
-4.13,
-2.11,
-6.49,
-10.38,
-6.54,
-5.27,
-10.35,
-11.88,
-13.65,
-12.82,
-11.38,
-15.75,
-13.69,
-10.58,
-13.01,
-13.63,
-10.63,
-16.32,
-15.13,
-14.21,
-11.72,
-15.56,
-14.3,
-16.2,
-14.54,
-14.64,
-17.67,
-16.52,
-11.76,
-12.61,
-10.07,
-8.29,
-5.84,
-2.3,
-5.28,
-4.63,
-3.04,
-2.15,
-3.38,
-1.23,
3.38,
-1.91,
-1.73,
-2.44,
-6.58,
-7.06,
-6.66,
-9.43,
-11.7,
-4.7,
-5.3,
-3.47,
-9.51,
-9.39,
-8.48,
-7.26,
-7.75,
-7.25,
-8.98,
-10.43,
-10.39,
-10.39,
-10.57,
-13.18,
-10.38,
-11.37,
-9.83,
-6.47,
-7.76,
-5.95,
-7.21,
-1.73,
0.07,
-1.37,
-0.77,
0.67,
-0.36,
1.93,
-1.35,
-3.91,
-9.02,
-2.33,
-2.27,
-6.31,
-6.63,
-2.01,
-2.04,
-4.61,
-11.68,
-7.02,
-5.48,
-7.42,
-7.51,
-5.92,
-7.54,
-5.9,
-10.28,
-11.82,
-15.66,
-12.1,
-13.23,
-10.75,
-5.05,
-4.79,
-5.48,
-6.31,
-4.06,
-0.28,
-0.43,
0.03,
4.58,
1.45,
1.73,
2.82,
0.45,
0.4,
0.31,
-3.36,
0.52,
-1.26,
2.41,
-5.38,
-6.07,
-2.41,
-1.42,
-1.65,
-2.9,
1.36,
0.15,
-5.27,
-3.45,
-0.1,
-5.8,
-4.63,
-3.64,
-3.5,
-3.8,
-3.69,
-2.51,
-3.66,
-0.36,
-2.09,
1.34,
-0.54,
0.56,
2.49,
3.72,
5.99,
6.27,
5.84,
2.9,
3.92,
7.17,
5.67,
5.69,
3.83,
2.73,
2.1,
-0.95,
-2.17,
-1.91,
-1.91,
-3.16,
-2.15,
0.23,
-6.01,
-4.01,
-3.15,
-5.18,
-6.46,
-6.45,
-3.33,
-1.52,
-3.12,
-1.75,
-1.07,
1.49,
2.89,
2.08,
2.25,
0.22,
3.14,
6.98,
9.5,
10.86,
6.81,
6.74,
9.37,
9.17,
7.54,
3.21,
6.02,
2.58,
2.6,
1.2,
-0.21,
-0.6,
-1.05,
-0.05,
3.96,
0.66,
-0.16,
-1.64,
1.27,
0.97,
-0.3,
-5.28,
-2.22,
-1.76,
-1.75,
-2.04,
-0.69,
0.0,
-1.2,
-2.39,
-0.6,
5.37,
2.87,
2.03,
3.19,
7.06,
5.25,
4.76,
7.74,
5.44,
7.24,
8.33,
6.29,
4.84,
-0.36,
-1.05,
1.3,
2.35,
1.15,
-2.79,
-0.31,
-2.87,
-0.56,
-0.2,
-2.34,
-2.87,
-2.88,
-5.54,
-3.64,
0.92,
3.92,
2.22,
3.07,
4.4,
3.82,
3.56,
4.41,
4.5,
7.61,
7.12,
8.2,
7.25,
9.15,
9.93,
10.57,
10.78,
8.88,
8.61,
6.99,
11.33,
6.69,
3.16,
4.24,
3.77,
5.54,
2.77,
1.91,
4.44,
4.69,
4.52,
5.21,
4.01,
3.07,
3.4,
2.69,
3.83,
2.49,
0.82,
3.63,
4.56,
3.2,
2.62,
6.18,
11.44,
9.88,
10.23,
12.19,
14.08,
16.64,
17.03,
16.4,
17.35,
18.83,
19.44,
15.41,
16.33,
13.84,
10.28,
14.41,
10.14,
9.87,
8.3,
5.72,
10.04,
13.12,
14.73,
6.7,
7.35,
6.57,
8.37,
7.43,
6.14,
7.03,
10.24,
8.97,
9.77,
11.25,
10.54,
8.6,
10.65,
10.46,
9.18,
11.26,
7.7,
10.78,
12.23,
11.13,
9.96,
14.24,
12.33,
9.95,
10.17,
6.77,
6.71,
5.8,
7.53,
5.18,
4.03,
4.14,
4.41,
4.76,
4.49,
3.21,
3.35,
-0.78,
1.92,
1.93,
1.16,
-1.95,
2.93,
3.57,
2.22,
6.28,
9.28,
6.35,
6.69,
7.32,
9.29,
13.81,
14.71,
16.75,
15.99,
14.09,
16.17,
18.04,
19.99,
14.26,
11.87,
12.95,
16.03,
13.52,
12.34,
11.91,
14.76,
13.83,
15.51,
14.27,
15.25,
14.28,
12.45,
12.37,
13.41,
12.07,
12.51,
13.26,
12.66,
13.21,
11.34,
13.04,
17.48,
15.88,
15.83,
20.3,
22.78,
22.0,
22.99,
20.02,
24.98,
24.83,
28.16,
28.24,
28.97,
27.03,
26.73,
26.95,
25.87,
24.71,
27.28,
23.12,
24.42,
22.67,
21.42,
23.82,
23.27,
21.33,
21.56,
22.73,
21.72,
22.0,
20.37,
15.94,
18.25,
18.54,
15.77,
14.73,
15.09,
15.2,
17.23,
16.19,
17.27,
20.73,
22.1,
18.26,
21.29,
23.43,
24.5,
24.6,
25.73,
25.6,
27.9,
27.85,
25.92,
25.9,
25.34,
20.73,
21.23,
22.48,
21.44,
22.27,
21.93,
23.02,
24.63,
25.09,
23.61,
22.87,
23.22,
21.36,
19.03,
17.12,
17.62,
16.35,
17.78,
18.98,
18.59,
21.41,
23.76,
24.94,
24.12,
27.8,
29.23,
29.97,
29.47,
30.58,
28.53,
30.67,
33.93,
32.82,
29.07,
28.61,
24.99,
27.34,
33.36,
29.55,
23.97,
27.09,
27.31,
30.38,
29.41,
33.21,
31.51,
28.95,
29.05,
31.04,
29.92,
29.72,
29.29,
27.02,
25.51,
29.09,
31.17,
32.89,
34.57,
35.01,
37.4,
37.96,
39.08,
37.86,
44.64,
44.91,
44.16,
44.37,
45.32,
45.62,
47.78,
44.25,
41.0,
44.3,
41.51,
38.42,
36.46,
34.65,
39.96,
42.49,
36.91,
39.94,
38.92,
39.27,
38.07,
41.12,
37.58,
36.97,
33.91,
32.66,
30.99,
30.52,
33.32,
33.5,
35.96,
34.92,
34.99,
35.12,
33.45,
34.33,
34.49,
39.15,
41.95,
40.9,
38.26,
37.75,
40.46,
41.52,
41.27,
42.44,
44.84,
39.87,
37.45,
36.81,
35.25,
35.75,
33.88,
33.25,
32.6,
34.48,
33.98,
34.6,
35.76,
36.55,
33.79,
34.11,
32.52,
33.06,
30.08,
33.4,
34.03,
34.17,
34.03,
34.39,
36.74,
41.29,
40.41,
40.87,
43.66,
45.7,
45.49,
42.95,
43.36,
44.45,
44.56,
46.79,
45.52,
46.93,
45.1,
44.37,
40.45,
39.65,
39.79,
40.28,
41.84,
38.53,
35.52,
40.38,
40.4,
36.97,
34.2,
36.11,
36.18,
37.08,
36.66,
36.63,
38.93,
38.41,
36.87,
37.38,
40.59,
42.77,
41.76,
42.86,
44.2,
46.82,
50.3,
49.54,
52.96,
50.73,
51.14,
52.42,
49.68,
47.05,
44.74,
45.64,
44.73,
43.91,
42.37,
47.75,
44.83,
46.99,
45.13,
44.19,
45.19,
47.3,
44.49,
43.23,
41.36,
45.19,
46.42,
44.48,
43.51,
43.96,
46.86,
45.87,
46.04,
48.6,
48.39,
49.45,
53.87,
56.74,
55.81,
57.98,
57.53,
55.06,
56.35,
53.49,
52.2,
56.08,
55.37,
53.8,
53.54,
50.27,
49.44,
46.45,
44.7,
46.71,
41.29,
47.57,
46.3,
48.57,
45.59,
46.38,
45.7,
43.78,
47.36,
50.17,
49.1,
46.31,
46.96,
44.04,
45.86,
47.07,
48.76,
49.7,
50.71,
49.5,
53.23,
55.98,
56.64,
55.51,
57.68,
57.29,
54.92,
57.31,
56.27,
52.14,
52.61,
50.15,
51.29,
52.66,
52.76,
52.8,
53.04,
49.09,
47.16,
46.43,
48.34,
49.06,
52.03,
50.87,
50.94,
49.18,
49.3,
50.53,
49.68,
47.47,
50.09,
49.5,
52.04,
51.7,
54.87,
57.26,
60.04,
57.12,
59.77,
61.82,
60.39,
61.77,
61.67,
62.78,
59.96,
56.94,
57.54,
59.05,
55.12,
54.78,
56.62,
57.01,
56.76,
55.22,
55.76,
51.08,
49.08,
52.68,
51.95,
53.54,
54.88,
52.77,
54.78,
49.98,
48.49,
48.37,
50.16,
48.93,
54.04,
57.35,
57.75,
54.41
]

export default GMSL;